"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importStar(require("styled-components"));
const Table = styled_components_1.default.table `
  width: 100%;
  border-spacing: 0;
  line-height: inherit;
  font-weight: inherit;
  font-size: inherit;
  font-style: inherit;
  color: inherit;
  border-color: grey;
  font-variant: inherit;

  tr {
    :last-child {
      td {
        border-bottom: 0;
      }
    }
  }
`;
exports.Table = Table;
const Tr = styled_components_1.default.tr `
  ${(props) => props.highlight &&
    styled_components_1.css `
      td {
        border-bottom: 5px solid ${(props) => props.theme.colors.borderDim};
      }
    `}
`;
exports.Tr = Tr;
const TdStyles = styled_components_1.css `
  vertical-align: ${(props) => props.verticalAlign || "top"};
  text-align: ${(props) => props.align || "left"};
  padding: ${(props) => props.tight
    ? `${props.theme.spacing.xs} calc(${props.theme.spacing.medium} / 2)`
    : `${props.theme.spacing.small} calc(${props.theme.spacing.medium} / 2)`};
  border-bottom: 1px solid ${(props) => props.theme.colors.borderDim};

  &:first-child {
    padding-left: ${(props) => props.theme.spacing.medium};
  }

  &:last-child {
    padding-right: ${(props) => props.theme.spacing.medium};
  }
`;
const Th = styled_components_1.default.th `
  ${TdStyles}
  font-weight: 600;
`;
exports.Th = Th;
const Td = styled_components_1.default.td `
  ${TdStyles}
`;
exports.Td = Td;
const Thead = styled_components_1.default.thead ``;
exports.Thead = Thead;
const TBody = styled_components_1.default.tbody ``;
exports.TBody = TBody;
const Tfoot = styled_components_1.default.tfoot `
  td {
    border-top: 1px solid ${(props) => props.theme.colors.borderDim};
  }
`;
exports.Tfoot = Tfoot;
